export const getFieldLabel = (label?: string) =>
  label?.replace(/\*.*$/, "").trim() || "This field";

export const getValidationMessage = (
  input: HTMLInputElement,
  label?: string,
): string => {
  const fieldName = getFieldLabel(label);

  if (input.validity.valueMissing) {
    return `${fieldName} is required.`;
  }
  if (input.validity.typeMismatch) {
    if (input.type === "email") {
      return "Please enter a valid email address.";
    }
    return `Please enter a valid ${fieldName.toLowerCase()}.`;
  }
  if (input.validity.patternMismatch) {
    return input.title || `Please enter a valid ${fieldName.toLowerCase()}.`;
  }
  if (input.validity.tooShort) {
    return `Please enter at least ${input.minLength} characters.`;
  }
  if (input.validity.tooLong) {
    return `Please enter no more than ${input.maxLength} characters.`;
  }

  return "Please enter a valid value.";
};
